import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsTravelSelectionBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsTravelSelectionBlockEntity
